var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2515",
    d: "M0-682.665H40v40H0Z",
    transform: "translate(0 682.665)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2505",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2507",
    transform: "translate(30.166 -678.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2509",
    d: "M2.444.95H.1a.85.85,0,0,1,0-1.7H2.444a.85.85,0,0,1,0,1.7Z",
    transform: "translate(0.75 0.75)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2511",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2513",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2519",
    transform: "translate(27.061 19.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2521",
    d: "M8.653.95H.1a.85.85,0,1,1,0-1.7H8.653a.85.85,0,0,1,0,1.7Z",
    transform: "translate(0.75 0.75)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2523",
    transform: "translate(24.306 -0.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2525",
    d: "M-228.181-303.143h-9.375a3.2,3.2,0,0,1-3.194-3.194v-19.219a3.2,3.2,0,0,1,3.194-3.194h9.375a3.2,3.2,0,0,1,3.194,3.194v19.219A3.2,3.2,0,0,1-228.181-303.143Zm-9.375-23.906a1.5,1.5,0,0,0-1.494,1.494v19.219a1.5,1.5,0,0,0,1.494,1.494h9.375a1.5,1.5,0,0,0,1.494-1.494v-19.219a1.5,1.5,0,0,0-1.494-1.494Z",
    transform: "translate(240.749 328.749)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2527",
    transform: "translate(-0.069 6.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2529",
    d: "M-543.711-260.8h-30.625a2.415,2.415,0,0,1-2.413-2.413v-23.125a2.415,2.415,0,0,1,2.413-2.413h22.812a.85.85,0,0,1,.85.85.85.85,0,0,1-.85.85h-22.812a.713.713,0,0,0-.713.713v23.125a.713.713,0,0,0,.713.713h30.625a.713.713,0,0,0,.713-.713v-7.812a.85.85,0,0,1,.85-.85.85.85,0,0,1,.85.85v7.812A2.415,2.415,0,0,1-543.711-260.8Z",
    transform: "translate(576.749 288.749)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2531",
    transform: "translate(12.119 33.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2533",
    d: "M.1,6.106a.85.85,0,0,1-.85-.85V.1A.85.85,0,0,1,.95.1V5.256A.85.85,0,0,1,.1,6.106Z",
    transform: "translate(0.75 0.75)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2535",
    transform: "translate(21.494 33.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2537",
    d: "M.1-81.894a.85.85,0,0,1-.85-.85V-87.9a.85.85,0,0,1,.85-.85.85.85,0,0,1,.85.85v5.156A.85.85,0,0,1,.1-81.894Z",
    transform: "translate(0.75 88.75)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2539",
    transform: "translate(7.431 38.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2541",
    d: "M18.85.95H.1a.85.85,0,0,1,0-1.7H18.85a.85.85,0,1,1,0,1.7Z",
    transform: "translate(0.75 0.75)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2551",
    transform: "translate(2.119 28.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2553",
    d: "M-198.524.95H-227.9a.85.85,0,0,1-.85-.85.85.85,0,0,1,.85-.85h29.375a.85.85,0,0,1,.85.85A.85.85,0,0,1-198.524.95Z",
    transform: "translate(228.749 0.75)",
    fill: "#09143a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/Warranty.df65b67f9fd281c9f17915b1793698be.svg";
export { ForwardRef as ReactComponent };